module.exports = __webpack_public_path__ + "static/img/2.2fa7203.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-educacion/2.png
// module id = QF6p
// module chunks = 0